import React from 'react';
import Button from '../Button/Button';
import googleAdsLogo from '../../../assets/GoogleAdsLogo.png';
import facebookLogo from '../../../assets/facebookLogo.svg';
import tikTokLogo from '../../../assets/tikTokLogo.webp';
import css from './Popups.module.css';

const AddSourcePopup = ({ onClose, onClick }) => (
  <>
    <h1 className={css.title}>Connect new Data Source</h1>
    <div className={css.sourcesWrapper}>
      <div className={css.sourceWrapper} onClick={onClick.bind(this, 'Google Ads')}>
        <img alt="Google Ads Logo" src={googleAdsLogo} />
        <p className={css.sourceName}>Google Ads</p>
      </div>
      <div
        className={css.sourceWrapper}
        onClick={onClick.bind(this, 'Facebook Ads')}
      >
        <img alt="Facebook Logo" src={facebookLogo} />
        <p className={css.sourceName}>Facebook Ads</p>
      </div>
      {/* <div
        className={css.sourceWrapper}
        onClick={onClick.bind(this, 'TikTok Ads')}
      >
        <img alt="Tiktok Logo" src={tikTokLogo} />
        <p className={css.sourceName}>TikTok Ads</p>
      </div> */}
    </div>
    <div className={css.btnWrapper}>
      <Button styled="close" title="Cancel" onClick={onClose} />
    </div>
  </>
);

export default AddSourcePopup;
